var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{class:_vm.showSlot ? 'col-8' : 'col-12'},[_c('div',{staticClass:"page-title-box"},[_c('h4',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.title))])])]),(_vm.showSlot)?_c('div',{staticClass:"col-4 d-flex flex-row-reverse align-items-center"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }